<template>
    <popup-modal ref="popupRef" @cancelmodal="handleCancel">
        <div ref="popupContentRef" class="Popup Detail html" :class="this.classes">
            <div class="heading" v-if="componentData.title">
                <h3>{{ trans(componentData.title) }}</h3>
            </div>
            <div class="inner">
                <div class="Message" v-html="trans(componentData.message)"></div>
                <slot name="after_message"></slot>
            </div>
            <div class="footer">
                <nav>
                    <button class="more outline" @click="handleCancel">
                        <span class="title">{{ trans(componentData.cancelButton) }}</span>
                    </button>
                    <button class="more" @click="handleConfirm">
                        <span class="title">{{ trans(componentData.okButton) }}</span>
                    </button>
                </nav>
            </div>
        </div>
    </popup-modal>
</template>

<script>
import {defineComponent, reactive, ref } from "vue";

import PopupModal from "components/popupModal.vue";
import trans from "helpers/_translation";

export default defineComponent({
    name: "PopupHtml",
    components: {
        PopupModal
    },
    props: {
        classes: {
            type: [ Boolean, String ],
            default: ""
        },
        confirmHandler: {
            type: Function,
            default: () => {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            }
        },
        cancelHandler: {
            type: Function,
            default: () => {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            }
        }
    },
    setup(props) {
        const popupRef = ref();
        const popupContentRef = ref();

        const componentDefaults = {
            title: 'Weet u het zeker?',
            message: '',
            okButton: 'Doorgaan',
            cancelButton: 'Annuleer',
            switchId: '',
            switchTitle: ''
        };
        const componentData = reactive({
            ...componentDefaults
        });
        // Private variables
        const resolveData = reactive({
            resolvePromise: undefined,
            rejectPromise: undefined
        });

        const show = (opts = {}) => {
            Object.keys(componentData).forEach(key => {
                componentData[key] = opts[key] || componentDefaults[key];
            });
            // Once we set our config, we tell the popup modal to open
            popupRef.value.open();
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                resolveData.resolvePromise = resolve;
                resolveData.rejectPromise = reject;
            });
        };

        const handleConfirm = () => {
            props.confirmHandler(popupContentRef.value).then(() => {
                popupRef.value.close();
                resolveData.resolvePromise(true);
            }).catch(() => {
                // Handle error
            });
        };

        const handleCancel = () => {
            props.cancelHandler(popupContentRef.value).then(() => {
                popupRef.value.close();
                resolveData.resolvePromise(false);
            }).catch(() => {
                // Handle error
            });
        };

        return {
            popupRef,
            popupContentRef,
            trans,
            componentData,

            show,
            handleConfirm,
            handleCancel
        }
    }
});
</script>